<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        title='提成计算'
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='850'
      >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-card-subtitle class="px-0 pt-1">
            项目奖金：
            <span :class="`${$isMobile ? 'size-20': 'size-20'} grey--text font-family-Impact`">¥{{item.data.product.commissionPrice * item.data.contract.productNumber}}</span>
            &nbsp;&nbsp;
            已发奖金：
            <span :class="`${$isMobile ? 'size-20': 'size-20'} blue--text font-family-Impact`">¥{{usedMoney}}</span>({{usedRatio}}%)
            &nbsp;&nbsp;
            剩余奖金：
            <span :class="`${$isMobile ? 'size-20': 'size-20'} orange--text font-family-Impact`">¥{{surpluMoney}}</span>({{surpluRatio}}%)
            &nbsp;&nbsp;
            本次可提奖金：
            <span :class="`${$isMobile ? 'size-20': 'size-20'} green--text font-family-Impact`">¥{{thisMoney}}</span>({{thisRatio}}%)
            <span v-if="item.data.again === 1" class="red--text">【续报工单】</span>
          </v-card-subtitle>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12" md='4'>
                <v-text-field label="本次奖金比例" suffix="%" :rules="numberRang" @input="commissionRatioNow" hide-details='auto' outlined v-model="form.commissionRatio"></v-text-field>
              </v-col>
              <v-col cols="12" md='4'>
                <v-text-field label="本次奖金标准" readonly suffix="¥" :rules="number" hide-details outlined v-model="form.money"></v-text-field>
              </v-col>
              <v-col cols="12" md='4' class="grey--text mt-2">
                例如：项目材料受理，发放30%，公示通过后发放70%
              </v-col>
            </v-row>
            <div class="my-3">
              提成明细(<span class="red--text">请先输入本次提成比例</span>)
              <v-divider class="mb-2"></v-divider>
              <v-row v-for="(item, idx) in form.commissionSettleList" :key="idx">
                <v-col cols="12" md='3'>
                  <base-marerial-user-select :rules="required" outlined :dense='false' :multiple='false' label='提成人员' hide-details v-model="form.commissionSettleList[idx].receiveUserId"></base-marerial-user-select>
                </v-col>
                <v-col cols="12" md='2'>
                  <v-text-field label="员工状态" suffix="%" @input="commissionRatio($event, idx)" :rules="number" hide-details='auto' outlined v-model="form.commissionSettleList[idx].formalStatus"></v-text-field>
                  </v-col>
                <v-col cols="12" md='2'>
                  <v-text-field label="提成比例" suffix="%" @input="commissionRatio($event, idx)" :rules="number" hide-details='auto' outlined v-model="form.commissionSettleList[idx].commissionRatio"></v-text-field>
                </v-col>
                <v-col cols="12" md='3'>
                  <v-text-field label="提成金额" readonly suffix="¥" :rules="number" hide-details outlined v-model="form.commissionSettleList[idx].money"></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="text-right">
                  <v-btn class="my-2 ml-n3" small depressed @click="moveSettles(form.commissionSettleList, idx)" :disabled='form.commissionSettleList.length <= 1' fab color="primary">
                    <v-icon dark>mdi-minus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
            <v-row class="mb-3">
              <v-col cols="12">
                <v-btn block  color="primary" @click="addSettles()" outlined><v-icon>mdi-plus</v-icon>新增</v-btn>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" :disabled="form.commissionSettleList.length  === 0" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
    <v-snackbar v-model="tip.show" timeout='3000' centered rounded="pill" color="warning"><v-icon>mdi-alert-circle-outline</v-icon>&nbsp;
      <span class="font-weight-bold">{{ tip.text }}</span>
      <template v-slot:action="{ attrs }">
        <v-btn text fab v-bind="attrs" small @click="tip.show = false"><v-icon>mdi-close</v-icon></v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { save } from '@/api/order/commission.js'

  export default {
    name: 'CommissionSettle',
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        array: [
          value => value.length > 0 || '此项为必填项!'
        ],
        number: [
          value => (/^[0-9]+(.[0-9]{1,2})?$|^(0|[1-9][0-9]*)$/.test(value) && !!value) || `必填只能为数字`,
        ],
        numberRang: [
          value => (/^[0-9]+(.[0-9]{1,2})?$|^(0|[1-9][0-9]*)$/.test(value) && !!value && value > 0 && value <= 100) || `只能是>0且<=${this.thisRatio}的数字`,
        ],
        tip: { show: false, text: '' },
        form: {
          money: '',
          remark: '',
          orderId: '',
          productId: '',
          contractId: '',
          orderStatus: '',
          commissionRatio: '',
          commissionSettleList: []
        },
        defForm: {
          money: '',
          remark: '',
          orderId: '',
          productId: '',
          contractId: '',
          orderStatus: '',
          commissionRatio: '',
          commissionSettleList: [
            {
              id: '',
              money: '',
              remark: '',
              formalStatus: '',
              receiveUserId: '',
              commissionRatio: '',
            }
          ]
        },
        commissionSettle: {
          id: '',
          money: '',
          remark: '',
          formalStatus: '',
          receiveUserId: '',
          commissionRatio: '',
        },
        defCommissionSettle: {
          id: '',
          money: '',
          remark: '',
          formalStatus: '',
          receiveUserId: '',
          commissionRatio: '',
        }
      }
    },
    methods: {
      commissionRatio (even, idx) {
        if (even && this.form.money) {
          const formalStatusRatio = this.form.commissionSettleList[idx].formalStatus / 100
          const ratio = this.form.commissionSettleList[idx].commissionRatio
          this.form.commissionSettleList[idx].money = (this.form.money * formalStatusRatio * (ratio / 100)).toFixed(2)
        }
      },
      commissionRatioNow (val) {
        this.form.money = 0.00
        if (val && val > 0 && val <= 100) {
          this.form.money = (val / 100 * (this.item.data.product.commissionPrice * this.item.data.contract.productNumber)).toFixed(2)
        }
        this.form.commissionSettleList.forEach((obj, index) => {
          if (obj.commissionRatio) {
            this.form.commissionSettleList[index].money = (this.form.money * (this.form.commissionSettleList[index].formalStatus / 100) * (obj.commissionRatio / 100)).toFixed(2)
          }
        })
      },
      moveSettles (item, idx) {
        item.splice(idx, 1)
      },
      addSettles () {
        this.commissionSettle = JSON.parse(JSON.stringify(this.defCommissionSettle))
        this.form.commissionSettleList.push(this.commissionSettle)
      },
      setSettles () {
        this.form.commissionSettleList = []
        this.allPerson.forEach((obj) => {
          this.commissionSettle = JSON.parse(JSON.stringify(this.defCommissionSettle))
          this.commissionSettle.receiveUserId = obj.id
          this.form.commissionSettleList.push(this.commissionSettle)
        })
      },
      save () {
        if (this.$refs.form.validate() && this.checkForm()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      checkForm() {
        if (this.thisRatio < this.form.commissionRatio) {
          this.tip = { show: true, text: `本次项目提成比例不得超过${this.thisRatio}%` }
          return false
        }
        if (this.surpluRatio < this.form.commissionRatio) {
          this.tip = { show: true, text: `项目总体提成比例不得超过${this.surpluRatio}%` }
          return false
        }
        let allCommissionRatio = 0
        this.form.commissionSettleList.forEach((obj) => {
          if (obj.commissionRatio) {
            allCommissionRatio += Number(obj.commissionRatio)
          }
        })
        if (100 - allCommissionRatio < 0) {
          this.tip = { show: true, text: '各员工提成总比例不得超过100%' }
          return false
        }
        // 判断提成员工是否在协同人或负责任里
        this.form.commissionSettleList.forEach((obj) => {
          if (
            this.item.data.firstPersonList.filter((item => item.id === obj.receiveUserId)).length === 0
            &&
            this.item.data.assistPersonList.filter((item => item.id === obj.receiveUserId)).length === 0
          ) {
            this.tip = { show: true, text: '有员工不属于负责任/协同人' }
            return false
          }
        })
        return true
      },
      countSurpluRatio () {
        let r = 0
        this.item.data.commissionRecords.forEach(obj => {
          r += obj.commissionRatio
        })
        return 100 - r
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          this.form.orderId = this.item.data.id
          this.form.orderStatus = this.item.data.orderStatus
          this.form.productId = this.item.data.productId
          this.form.contractId = this.item.data.contractId
          this.setSettles()
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
        }
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      },
      allPerson () {
        const persions = []
        persions.push(...this.item.data.firstPersonList)
        persions.push(...this.item.data.assistPersonList)
        console.log(this.item.data, this.item.data.assistPersonList)
        return persions
      },
      cando () {
        this.item.data.commissionRecords.forEach(obj => {
          if (obj.orderInfo.orderStatus === this.form.orderStatus) {
            return false
          }
        })
        return true
      },
      usedMoney () {
        let s = 0
        this.item.data.commissionRecords.forEach(obj => {
          s += obj.money
        })
        return s
      },
      surpluMoney () {
        let s = 0
        this.item.data.commissionRecords.forEach(obj => {
          s += obj.money
        })
        return this.item.data.product.commissionPrice * this.item.data.contract.productNumber - s
      },
      surpluRatio () {
        return this.countSurpluRatio()
      },
      // 本次可提成比例
      thisRatio () {
        // 续报逻辑
        // 1、项目第一年申报后（系统显示已完成）提30%；本年项目通过（系统显示已通过）提剩余70%；
        // 2、未通过项目第二年复报后（系统显示已完成）提30%；本年通过后（系统显示已通过）提剩余40%；
        // 3、未通过项目第三年复报的项目复报后（系统显示已完成）提20%；本年通过后（系统显示已通过）提剩余20%
        if (this.item.data.again === 1) {
            if (this.item.data.orderStatus === 4) { // 已完成
              return this.item.data.againNum === 1 ? 30 : this.item.data.againNum === 2 ? 20 : 0
            } else if (this.item.data.orderStatus === 5) { // 已通过 可提剩余所有
              return this.countSurpluRatio()
            }
            return 0
          }
          return this.countSurpluRatio()
      },
      // 本次可提成金额
      thisMoney() {
        return this.item.data.product.commissionPrice * this.item.data.contract.productNumber * this.thisRatio / 100
      },
      usedRatio () {
        let r = 0
        this.item.data.commissionRecords.forEach(obj => {
          r += obj.commissionRatio
        })
        return r
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
